<template>
  <div class="user-wrap">
    <div v-if="!loadResult.ok" style="color: red">{{loadResult}}</div>
    <template v-else-if="user">
      <div class="user-meta">
        <div class="user-avatar" @click="openPhoto(0)">
          <avatar class="avatar" :user="user"/>
        </div>
        <div class="user-name">
          {{user.first_name}}{{user.last_name ? ' ' + user.last_name : ''}}
        </div>
        <div class="user-location">
          {{user.country && user.country.title}}, {{user.city && user.city.title}}
        </div>
        <div class="user-age">
          {{$i18n.t('user.sex.' + (user.sex === 2 ? 'male' : 'female'))}}, {{user.age}}
        </div>
        <btn
          link
          target="_blank"
          class="user-send-button"
          v-t="'profile.info.send_message'"
          :href="`https://t.me/MeetBot?start=user_${user.id}`"/>
      </div>

      <!--<interests :interests="['telegraf', 'javascript', 'vue', 'telegraf', 'javascript', 'vue', 'telegraf', 'javascript', 'vue', 'telegraf', 'javascript', 'vue', 'telegraf', 'javascript', 'vue', 'telegraf', 'javascript', 'vue']"/>-->

      <div class="user-photos" v-if="user.photos.length && !user.photos[0][0].url.match(/no_avatar/)">

        <user-profile-title class="user-photos-title" :counter="user.photos.length">
          {{$i18n.t('profile.info.photos')}}
        </user-profile-title>

        <div class="user-photos-items">
          <div class="img-row" v-for="row in viewAllPhotos ? Math.ceil(user.photos.length / 4) : 1" :key="row">
            <a href="javascript://" v-for="(photo, i) in user.photos.slice((row-1) * 4, row * 4)" :key="i">
              <img :src="photo[0].url" @click="openPhoto((row - 1) * 4 + i)" alt="Image"/>
            </a>
          </div>
          <vue-gallery-slideshow
            :images="photos"
            :index="index"
            @close="index = null"/>
        </div>
        <sticky-btn
          v-if="user.photos.length > 4 && !viewAllPhotos"
          @click="showAllPhotos">
          {{$t('profile.info.show_all_photos')}}
        </sticky-btn>
      </div>
      <div class="user-about" v-if="user.about && user.about.length">
        <user-profile-title v-t="'profile.info.about'"/>
        <p>
          <template v-for="(para, i) in user.about.split('\n')">
            {{para}}
            <br :key="i"/>
          </template>
        </p>
      </div>
      <sticky-btn
        v-if="user.id === authUser.id"
        link
        target="_blank"
        href="https://t.me/MeetBot?start=edit_profile">
        {{$t('profile.info.edit_profile')}}
      </sticky-btn>
    </template>
  </div>
</template>


<script>
  import VueGallerySlideshow from 'vue-gallery-slideshow'

  import Btn from '@/components/core/Btn.vue'
  import StickyBtn from '@/components/core/StickyBtn.vue'

  import Avatar from '@/components/core/Avatar.vue'

  // import Interests from '../data/UserProfile/components/Interests.vue'
  import UserProfileTitle from '@/components/UserProfile/UserProfileTitle.vue'

  import {
    authUser,
    defaultAuth,
  } from '@/mixins/auth'

  import {
    loadProfile,
  } from '@/functions/profile'

  export default {
    name: 'UserProfile',
    mixins: [
      authUser,
      defaultAuth,
    ],
    components: {
      VueGallerySlideshow,

      Btn,
      StickyBtn,

      Avatar,
      // Interests,
      UserProfileTitle,
    },
    data() {
      return {
        user: {},

        loading: true,
        loadResult: {},

        index: null,
        viewAllPhotos: false,
      }
    },
    methods: {
      applyResult(result) {
        this.loadResult = result

        if (result.ok) {
          this.user = result.result
        }

        this.loading = false

        return result
      },

      openPhoto(index) {
        this.index = index
      },
      showAllPhotos() {
        this.viewAllPhotos = true
      },
    },
    computed: {
      photos() {
        return this.user.photos
          .filter(v => v && v[1] && v[1].url)
          .map(photos => photos[1].url)
      }
    },
    beforeRouteEnter(to, from, next) {
      loadProfile(Number(to.params.id))
        .then(result => next(vm => vm.applyResult(result)))
    },
    async beforeRouteUpdate(to, from, next) {
      const result = await loadProfile(Number(to.params.id))

      this.applyResult(result)

      next()
    },
  }
</script>

<style scoped lang="stylus">
  .user-wrap
    padding-top 30px
    @media (max-width: 510px)
      padding-top 15px

    .user-meta
      overflow hidden
      display grid
      grid-column-gap 30px
      grid-template-columns auto 1fr
      grid-template-rows auto
      grid-template-areas: "avatar name"\
      "avatar location"\
      "avatar age"\
      "avatar button"
      @media (max-width: 510px)
        grid-column-gap 15px
        margin-left -5px

      .user-avatar
        grid-area avatar
        margin 0
        width 135px
        height 135px
        cursor pointer
        @media (max-width: 510px)
          width 110px
          height 110px

        .avatar
          width 135px
          line-height 136px
          font-size 30px
          @media (max-width: 510px)
            width 110px
            line-height 111px

      .user-name, .user-location, .user-age
        white-space nowrap
        text-overflow ellipsis
        overflow hidden

      .user-name
        grid-area name
        font-size 24px
        font-weight 500
        @media (max-width: 510px)
          font-size 19px

      .user-location
        grid-area location
        color #7a7a7a
        font-weight 500
        font-size 15px

      .user-age
        grid-area age
        color #7a7a7a
        font-size 15px

      .user-send-button
        grid-area button
        margin 12px 0 0


    .user-photos
      margin 30px 0 0

      .user-photos-items
        .img-row + .img-row
          margin-top 13px

        .img-row
          display flex
          flex-direction row
          flex-wrap nowrap

          a + a
            margin-left 13px

        a
          display inline-block
          width calc((100% - 13px * 3) / 4)
          height calc((100% - 13px * 3) / 4)

          img
            width 100%
            border-radius .25rem

    .user-about
      font-size 15px
      line-height 21px
      word-break break-word
      margin-top 25px

      p
        margin-top 10px
</style>
